import React from 'react';
import { NavLink, Outlet, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/admin.css';

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="admin-body">
      <header className="site-header">
        <div className="container nav">
          <Link to="/" className="brand" aria-label="Thế Thảo Pharma">
            <img src="/assets/img/logo-icon.svg" alt="" className="brand__icon" width="56" height="56" />
            <span className="brand__text">
              <span className="brand__name">THẾ THẢO PHARMA</span>
              <span className="brand__tagline">Admin Panel</span>
            </span>
          </Link>
          <div className="nav-cta" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            {user && (
              <span style={{ fontSize: '0.85rem', color: '#64748b' }}>
                Chào, <strong>{user.full_name || user.email}</strong>
              </span>
            )}
            <Link className="btn btn--ghost" to="/" style={{ padding: '8px 16px', fontSize: '.85rem' }}>
              ← Về site
            </Link>
            <button
              className="btn btn--primary"
              onClick={handleLogout}
              style={{ padding: '8px 16px', fontSize: '.85rem' }}
              type="button"
            >
              Đăng xuất
            </button>
          </div>
        </div>
      </header>

      <nav className="admin-tabs">
        <div className="container">
          <NavLink to="/admin/dashboard" className={({ isActive }) => (isActive ? 'admin-tab is-active admin-tab--highlight' : 'admin-tab admin-tab--highlight')}>
            ⚡ Dashboard Cty <span className="tab-pill">Incoming</span>
          </NavLink>
          <NavLink to="/admin/jobs" className={({ isActive }) => (isActive ? 'admin-tab is-active' : 'admin-tab')}>
            Vị trí tuyển dụng
          </NavLink>
          <NavLink to="/admin/applications" className={({ isActive }) => (isActive ? 'admin-tab is-active' : 'admin-tab')}>
            Hồ sơ ứng tuyển
          </NavLink>
          <NavLink to="/admin/news" className={({ isActive }) => (isActive ? 'admin-tab is-active' : 'admin-tab')}>
            Tin tức
          </NavLink>
          <NavLink to="/admin/partners" className={({ isActive }) => (isActive ? 'admin-tab is-active' : 'admin-tab')}>
            Đối tác
          </NavLink>
          <NavLink to="/admin/images" className={({ isActive }) => (isActive ? 'admin-tab is-active' : 'admin-tab')}>
            Ảnh site
          </NavLink>
          <NavLink to="/admin/settings" className={({ isActive }) => (isActive ? 'admin-tab is-active' : 'admin-tab')}>
            Cài đặt chung
          </NavLink>
          <NavLink to="/admin/account" className={({ isActive }) => (isActive ? 'admin-tab is-active' : 'admin-tab')}>
            Tài khoản
          </NavLink>
        </div>
      </nav>

      <main className="admin-main">
        <div className="container">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
